import { FieldFilter } from 'components/organisms/tasks/filters';
import { ApiGroupFilter } from 'utils/simple-search-filter/simple-search-filter';
import { ResourceManagementViewDefinition } from './types';

export const isValidViewDefinition = (
  viewDefinition: ResourceManagementViewDefinition,
): boolean => {
  return (
    viewDefinition.filter != null &&
    viewDefinition.filter.groupCriteria.filter((x) =>
      FieldFilter.isValid(x.criteria),
    ).length > 0
  );
};

export const viewDefinitionComparator = (
  oldDefinition: ResourceManagementViewDefinition,
  newDefinition: ResourceManagementViewDefinition,
): boolean => {
  if (oldDefinition.filter?.type !== newDefinition.filter?.type) {
    return true;
  }

  const oldFilters = (oldDefinition.filter?.groupCriteria ?? []).filter((x) =>
    FieldFilter.isValid(x.criteria),
  );
  const newFilters = (newDefinition.filter?.groupCriteria ?? []).filter((x) =>
    FieldFilter.isValid(x.criteria),
  );

  if (
    oldFilters.length !== newFilters.length ||
    ApiGroupFilter.toQueryStringFormatForGroups(oldFilters) !==
      ApiGroupFilter.toQueryStringFormatForGroups(newFilters)
  ) {
    return true;
  }

  return false;
};
